import React from 'react';
import {startOfWeek} from "date-fns";
import Grid from "@mui/material/Grid";
import moment from "moment";
import {addDays} from "../../../../../utils/GenericUtils";
import {Typography} from "@mui/material";
import itLocale from "date-fns/locale/it";

const ScadenziarioCalendarDays = ({currentMonth}) => {
	const days = [];
	
	let startDate = startOfWeek(currentMonth, {
		locale: itLocale
	});
	
	for (let i = 0; i < 7; i++) {
		days.push(
			<Grid item xs key={i + moment(addDays(startDate, i)).format("dddd")}>
				<Typography align={"center"} variant={"subtitle2"} style={{textTransform: "capitalize"}}>
					{moment(addDays(startDate, i)).format("dddd")}
				</Typography>
			</Grid>
		)
	}
	
	return (
		<React.Fragment>
			<Grid container spacing={3}>
				{days}
			</Grid>
		</React.Fragment>
	);
};

export default React.memo(ScadenziarioCalendarDays)
